module.exports = __webpack_public_path__ + "img/company-5.a2e55640.png";